<template>
  <div class="search">
    <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      />
    </svg>
    <label :for="name" class="visually-hidden">{{ label }}</label>
    <input
      :id="name"
      :value="value"
      :disabled="disabled"
      @input="updateValue"
      :placeholder="placeholderText"
      class="search-field"
      type="search"
    />
  </div>
</template>

<script>
import { debounce } from 'lodash'

import stringUtils from '@/components/mixins/stringUtils'

import { SEARCH_INPUT_DELAY } from '@/utils/searchInputDelay'

export default {
  name: 'SearchField',
  props: {
    disabled: { required: false, type: Boolean, default: false },
    label: { required: true, type: String },
    name: { required: true, type: String },
    placeholder: { required: false, type: String },
    value: { type: [String, Number] },
  },
  computed: {
    placeholderText() {
      return this.placeholder || this.$t('meta.search')
    },
    labelText() {
      return this.label || this.$t('meta.search')
    },
  },
  mixins: [stringUtils],
  methods: {
    updateValue(event) {
      this.emitInput(event.target.value)
    },
    emitInput: debounce(
      function (value) {
        this.$emit('input', value)
      },
      SEARCH_INPUT_DELAY,
      { trailing: true },
    ),
  },
}
</script>

<style lang="scss">
.search {
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
}
.search-icon {
  position: absolute;
  top: 50%;
  left: 7px;
  transform: translateY(-50%);
  width: 1.25rem;
  height: 1.25rem;
  color: #868686;
}

.search-field {
  display: block;
  width: 100%;
  height: var(--input-height);
  padding-left: 2rem;
  line-height: 1.5;
  background: #fff;
  border: 1px solid rgba(60, 60, 60, 0.26);
  box-shadow: inset 0 0 3px 0 rgba(215, 227, 230, 0.4);
  border-radius: var(--border-radius-m);
  font-size: 1rem;
}
</style>
